var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6,6.2V4.4C5.6,2,7.6,0,10,0s4.4,2,4.4,4.4v1.9h2.5c1,0,1.9,0.8,1.9,1.9v8.1c0,2.1-1.7,3.8-3.8,3.8H5 c-2.1,0-3.8-1.7-3.8-3.8V8.1c0-1,0.8-1.9,1.9-1.9H5.6z M7.5,6.2h5V4.4c0-1.4-1.1-2.5-2.5-2.5S7.5,3,7.5,4.4V6.2z M3.1,8.1v8.1 c0,1,0.8,1.9,1.9,1.9h10c1,0,1.9-0.8,1.9-1.9V8.1h-2.5v2.2c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9V8.1h-5v2.2 c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9V8.1H3.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyicon);
export default __webpack_public_path__ + "static/media/buyicon.1eb5d7af.svg";
export { ForwardRef as ReactComponent };